import "../styles/about.css";

export default function Levels(props) {

  return (
    <div>
      <h3>سطح بندی مشتریان :</h3>
    </div>
  );
}
